// extracted by mini-css-extract-plugin
export default {"wrapper":"Edit_wrapper__a1Sz3","wrapperHeader":"Edit_wrapperHeader__sHT4B"};